import { Application } from "@hotwired/stimulus"
import MapController from "./map_controller"
import MapContainerController from "./map_container_controller"
import SearchController from "./search_controller"
import FilterFormController from "./filter_form_controller"
import InfiniteScrollController from "./infinite_scroll_controller"
import RegistrationStepsController from "./registration_steps_controller"
import LogoPreviewController from "./logo_preview_controller"
import StarRatingController from "./star_rating_controller"
import CookieConsentController from "./cookie_consent_controller"
import FlashController from "./flash_controller"
import DeleteModalController from "./delete_modal_controller"
import FormSubmissionController from "./form_submission_controller"
import VisitorTrackingController from "./visitor_tracking_controller"
import ImpressionController from "./impression_controller"
import MarkdownPreviewController from "./markdown_preview_controller"
import ViewportFilterController from "./viewport_filter_controller"
import CostCalculatorController from "./cost_calculator_controller"

const application = Application.start()

// Register all controllers in controllers directory
// const controllers = import.meta.globEager("./**/*_controller.js")
// registerControllers(application, controllers)

// Eager load all controllers defined in the import map
// import { eagerLoadControllersFrom } from "@hotwired/stimulus-loading"
// eagerLoadControllersFrom("controllers", application)

// Register all controllers
application.register("map", MapController)
application.register("map-container", MapContainerController)
application.register("search", SearchController)
application.register("filter-form", FilterFormController)
application.register("infinite-scroll", InfiniteScrollController)
application.register("registration-steps", RegistrationStepsController)
application.register("logo-preview", LogoPreviewController)
application.register("star-rating", StarRatingController)
application.register("cookie-consent", CookieConsentController)
application.register("flash", FlashController)
application.register("delete-modal", DeleteModalController)
application.register("form-submission", FormSubmissionController)
application.register("visitor-tracking", VisitorTrackingController)
application.register("impression", ImpressionController)
application.register("markdown-preview", MarkdownPreviewController)
application.register("viewport-filter", ViewportFilterController)
application.register("cost-calculator", CostCalculatorController)
